/* Sofia's Spot: gift bundle picks (built 25 Oct 2026 on Jessie's yes, 9:34am: "Build the bundle fix and the brand link").
   Why: a tap on a bundle photo used to add that piece on its own and throw the cart open. In October 46% of phone carts
   started that way, 36% of them came straight back out within 2 minutes, and 4% bought, against 17% of shoppers who used
   the product's own button (hub_docs 499, section 2g).
   Now a tap on a bundle photo or tick only PICKS the piece. Nothing goes in the cart until the product's own Add to cart is
   pressed: it reads "Add 2 to cart" and carries the picks (they go in just before the product, through the shared cart
   queue, so the theme, gift wrap and the card add keep working exactly as before). When the page's own piece is already in
   the cart it reads "Add 1 extra to cart" and adds only the picks.
   One button (Jessie, 25 Oct 2026, 11:56am: "remove the additional add the whole box button? Now that the main add to cart
   updates with add 2 to cart, that seems incredibly intuitive"): the curated box's own add button is hidden, and "Pick the
   whole box" ticks every piece in one tap instead, so the whole box also goes in through Add to cart.
   Bundle and save: right after the picks are queued, sofia-bundle-save.js puts its code on the cart in the same queue,
   so the drawer opens with the saving already showing.
   The box scripts in sofia-curatedbox.liquid and sofia-giftbox.liquid still own the cart truth (a piece already in the
   cart shows "In your cart"); this file stops a tap from adding, keeps the picks and adds them on a press. Pick lines carry
   the same _bundle_* stamps and the same sofia_bundle_add event as before, plus pick: 1, so every read keeps working and
   the go-live date splits before from after. */
(function () {
  if (window.__sofiaPick) return; window.__sofiaPick = true;
  var PICK = 'sp-picked', WAIT = 'sp-wait';
  var Q = window.sofiaCartQueue = window.sofiaCartQueue || (function () {
    var tail = Promise.resolve();
    return function (task) { var run = tail.then(task, task); tail = run.catch(function () {}); return run; };
  })();
  function pub(name, data) { try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {} }
  function money(t) { var m = String(t || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : 0; }
  function fmt(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  function cfg() { var el = document.getElementById('cart-config'); try { return JSON.parse((el && el.textContent) || '{}'); } catch (e) { return {}; } }
  function openDrawer() {
    var T = window.Shopify && Shopify.theme;
    if (!(T && T.cart && T.cart.getCart && T.ajaxCart && T.ajaxCart.updateView)) return Promise.resolve();
    return Q(function () { return T.cart.getCart(); }).then(function (cart) {
      var c = cfg(); T.ajaxCart.updateView(c, cart); if (T.ajaxCart.showDrawer) T.ajaxCart.showDrawer(c);
    }).catch(function () {});
  }
  /* Bundle and save's code goes on in the same queue as the picks (sofia-bundle-save.js); never blocks an add. */
  function prime() { var S = window.sofiaBundleSave; try { return (S && S.prime) ? S.prime() : Promise.resolve(); } catch (e) { return Promise.resolve(); } }

  function isCbx(opt) { return opt.hasAttribute('data-cbx-opt'); }
  function cbOf(opt) { return opt.querySelector(isCbx(opt) ? '[data-cbx-pick]' : '[data-sgb-pick]'); }
  function hostOf(opt) { return opt.closest(isCbx(opt) ? '[data-cbx]' : '[data-sgb-wrap]'); }
  /* Not pickable: already in the cart, mid-change, or the page's own piece (it always goes in with the button). */
  function blocked(opt) { var c = opt.classList; return c.contains('in') || c.contains('has') || c.contains('busy') || c.contains('is-this'); }
  function priceOf(opt) { var p = opt.querySelector(isCbx(opt) ? '[data-cbx-price]' : '[data-sgb-price]'); return money(p && p.textContent); }
  function picksIn(root) {
    return [].filter.call((root || document).querySelectorAll('.' + PICK), function (o) { var cb = cbOf(o); return cb && cb.value && !blocked(o); });
  }
  function pickable(box) {
    return [].filter.call(box.querySelectorAll('[data-cbx-opt]'), function (o) { return !blocked(o) && cbOf(o); });
  }
  function formOf(el) { return (el && el.closest && el.closest('form')) || document.querySelector('.product__section--buttons form'); }
  function mainVid(form) { var v = form && form.querySelector('.formVariantId'); return v ? v.value : ''; }
  function boxOf(form) { return (form && form.querySelector('[data-cbx]')) || document.querySelector('[data-cbx]'); }
  function mainPrice(box) {
    var own = box && box.querySelector('.is-this [data-cbx-price]');
    if (own) return money(own.textContent);
    var el = document.querySelector('#product-price [data-sale-price]') || document.querySelector('#product-price [data-regular-price]');
    return money(el && el.textContent);
  }
  function mainInCart(box, form) {
    var mv = mainVid(form), own = (box && box.__cbxHas) || {};
    return !!(mv && own[mv]) || !!(box && box.querySelector('.is-this.has, .is-this.in'));
  }

  function lineFor(opt) {
    var cb = cbOf(opt), host = hostOf(opt), vid = cb.value, anchor = host.getAttribute('data-anchor'), build = host.getAttribute('data-build');
    if (isCbx(opt)) {
      var bid = host.getAttribute('data-box');
      return { item: { id: parseInt(vid, 10), quantity: 1, properties: { _bundle_anchor: anchor, _bundle_row: 'BOX', _bundle_surface: 'pdp', _bundle_build: build, _bundle_box: bid } },
        ev: { anchor: anchor, build: build, row: 'BOX', box: bid, arm: 'curated', variant_id: String(vid), product_id: cb.getAttribute('data-pid'), surface: 'pdp', pick: 1 } };
    }
    var row = cb.getAttribute('data-row');
    return { item: { id: parseInt(vid, 10), quantity: 1, properties: { _bundle_anchor: anchor, _bundle_row: row, _bundle_surface: 'pdp', _bundle_build: build } },
      ev: { anchor: anchor, build: build, row: row, variant_id: String(vid), product_id: cb.getAttribute('data-pid'), surface: 'pdp', pick: 1 } };
  }
  function addPicks(opts) {
    if (!opts.length) return Promise.resolve(true);
    var lines = opts.map(lineFor);
    return Q(function () {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lines.map(function (l) { return l.item; }) }) })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
    }).then(function () { lines.forEach(function (l) { pub('sofia_bundle_add', l.ev); }); return true; }, function () { return false; });
  }
  function clearPicks(opts) { opts.forEach(function (o) { o.classList.remove(PICK, WAIT, 'need'); }); refreshAll(); }

  /* Labels: the curated box's summary and its pick-all link, and the product's own Add to cart. */
  function setText(el, label) {
    if (el.__spMine == null) el.__spText = el.textContent;
    el.__spMine = label;
    if (el.textContent !== label) el.textContent = label;
  }
  function restoreText(el) {
    if (el.__spMine == null) return;
    if (el.textContent === el.__spMine && el.__spText != null) el.textContent = el.__spText;
    el.__spMine = null;
  }
  function words(n) { return n === 1 ? '1 extra' : n + ' extras'; }
  function boxUI(box) {
    var foot = box.querySelector('.cbx__foot'); if (!foot) return;
    var picks = picksIn(box), n = picks.length, sum = box.querySelector('.sp-sum'), all = box.querySelector('.sp-all');
    var open = pickable(box), allOn = open.length > 0 && open.every(function (o) { return o.classList.contains(PICK) || o.classList.contains(WAIT); });
    box.classList.toggle('sp-has-picks', n > 0);
    if (!all) { all = document.createElement('button'); all.type = 'button'; all.className = 'sp-all'; foot.appendChild(all); }
    all.hidden = !open.length;
    if (allOn) all.textContent = 'Unpick all';
    else {
      var bt = box.querySelector('.cbx__total strong'), free = box.querySelector('.cbx__free');
      all.textContent = 'Pick the whole box' + (bt ? ' · ' + bt.textContent.trim() : '') + (free && /ships free/i.test(free.textContent) ? ' · ships free' : '');
    }
    if (!n) { if (sum) sum.hidden = true; return; }
    var form = formOf(box), hasMain = mainInCart(box, form);
    var total = (hasMain ? 0 : mainPrice(box)) + picks.reduce(function (s, o) { return s + priceOf(o); }, 0);
    if (!sum) { sum = document.createElement('div'); sum.className = 'sp-sum'; foot.insertBefore(sum, foot.firstChild); }
    sum.hidden = false;
    sum.innerHTML = '<div class="sp-sum__row"><span>' + words(n) + ' picked</span><span>' + (hasMain ? 'Extras ' : 'This piece + ' + words(n) + ' ') +
      '<strong>' + fmt(total) + '</strong></span></div><div class="sp-sum__note">They go in when you press Add to cart below.</div>';
  }
  function mainUI() {
    document.querySelectorAll('.product__section--buttons .AddtoCart').forEach(function (b) {
      var form = formOf(b), n = picksIn(form || document).length;
      if (!n || b.disabled) { restoreText(b); return; }
      setText(b, mainInCart(boxOf(form), form) ? 'Add ' + words(n) + ' to cart' : 'Add ' + (n + 1) + ' to cart');
    });
  }
  function refreshAll() {
    document.querySelectorAll('.' + PICK).forEach(function (o) { if (blocked(o)) o.classList.remove(PICK); });
    document.querySelectorAll('[data-cbx]').forEach(boxUI);
    mainUI();
  }
  /* The old box scripts and the theme rewrite these labels (cart changes, a new size). Put ours back while picks exist,
     but never over a sold out or unavailable button. */
  function guardText(el) {
    if (!el || el.__spGuard || !('MutationObserver' in window)) return; el.__spGuard = true;
    new MutationObserver(function () {
      if (el.__spMine == null || el.textContent === el.__spMine) return;
      if (el.disabled) { el.__spMine = null; return; }
      el.__spText = el.textContent; el.textContent = el.__spMine;
    }).observe(el, { childList: true, characterData: true, subtree: true });
  }
  function note(box, text) {
    var m = box.querySelector('.sp-msg');
    if (!m) { m = document.createElement('p'); m.className = 'sp-msg'; box.querySelector('.cbx__foot').appendChild(m); }
    m.textContent = text; m.hidden = false; clearTimeout(m.__t); m.__t = setTimeout(function () { m.hidden = true; }, 4000);
  }

  function toggle(opt) {
    if (blocked(opt)) return;
    var cb = cbOf(opt); if (!cb) return;
    if (opt.classList.contains(PICK)) { opt.classList.remove(PICK); refreshAll(); return; }
    if (!cb.value) {
      /* It needs a choice first (a size, a colour or one of the photos): ask for it, and pick it once chosen. */
      opt.classList.add('need', WAIT);
      var s = opt.querySelector('[data-sgb-chip]') || opt.querySelector('[data-cbx-var], [data-sgb-var]');
      if (s) { try { s.focus({ preventScroll: true }); } catch (x) {} }
      return;
    }
    opt.classList.remove('need', WAIT); opt.classList.add(PICK); refreshAll();
  }
  function pickAll(box) {
    var open = pickable(box), allOn = open.length > 0 && open.every(function (o) { return o.classList.contains(PICK) || o.classList.contains(WAIT); });
    open.forEach(function (o) {
      if (allOn) { o.classList.remove(PICK, WAIT, 'need'); return; }
      if (o.classList.contains(PICK)) return;
      var cb = cbOf(o);
      if (cb && cb.value) { o.classList.remove('need', WAIT); o.classList.add(PICK); } else o.classList.add('need', WAIT);
    });
    refreshAll();
  }
  function mainPress(e, atc) {
    if (atc.disabled || atc.__sgGo) return;
    var form = formOf(atc), picks = picksIn(form || document);
    if (!picks.length || !mainVid(form)) return;
    if (mainInCart(boxOf(form), form)) {
      /* The page's own piece is already in the cart: the press adds only the picks. */
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
      clearPicks(picks);
      addPicks(picks).then(function (ok) { return ok ? prime() : null; }).then(openDrawer);
      return;
    }
    clearPicks(picks);
    addPicks(picks);
    prime();   /* queued between the picks and the theme's own add of this piece */
  }
  function boxAdd(box, picks) {
    /* Only reached if the box's own button shows (sofia-pick.css hides it): the picks go in through Add to cart. */
    var form = formOf(box), atc = form && form.querySelector('.AddtoCart');
    if (atc && !atc.disabled && mainVid(form)) { atc.click(); return; }
    note(box, 'Choose your option above first.');
  }

  /* Capture on window runs before every other handler on the page, so a tap is stopped before the old scripts add it. */
  window.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var all = t.closest('[data-cbx-all]');
    if (all) {
      var box = all.closest('[data-cbx]'); if (!box) return;
      var bp = picksIn(box); if (!bp.length) return;
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
      boxAdd(box, bp); return;
    }
    var atc = t.closest('.product__section--buttons .AddtoCart');
    if (atc) { mainPress(e, atc); return; }
    var chip = t.closest('[data-sgb-chip]');
    if (chip) {
      var copt = chip.closest('[data-sgb-opt]'), csel = copt && copt.querySelector('[data-sgb-var]');
      chip.__spWasChosen = !!(csel && csel.value === chip.getAttribute('data-v'));
      return;
    }
    var opt = t.closest('[data-cbx-opt], [data-sgb-opt]'); if (!opt) return;
    if (t.closest('select, option, [data-sgb-more], a, .sp-all')) return;
    var cb = cbOf(opt);
    if (!t.closest('label') && t !== cb) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    toggle(opt);
  }, true);
  /* A tap on one of the photos under "Pairs well with" chooses it (the old script) and picks it (here). */
  document.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest && e.target.closest('[data-sgb-chip]'); if (!chip) return;
    var opt = chip.closest('[data-sgb-opt]'); if (!opt || blocked(opt)) return;
    var cb = cbOf(opt);
    if (opt.classList.contains(PICK) && chip.__spWasChosen) opt.classList.remove(PICK);
    else if (cb && cb.value) { opt.classList.remove('need', WAIT); opt.classList.add(PICK); }
    refreshAll();
  });
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('.sp-all'); if (!a) return;
    e.preventDefault();
    var box = a.closest('[data-cbx]'); if (box) pickAll(box);
  });
  /* A size or colour chosen in a tile: pick it if the shopper had tapped it first; keep the totals right. */
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.matches || !t.matches('[data-cbx-var], [data-sgb-var]')) return;
    var opt = t.closest('[data-cbx-opt], [data-sgb-opt]'); if (!opt) return;
    if (opt.classList.contains(WAIT) && t.value && e.isTrusted) { opt.classList.remove(WAIT, 'need'); opt.classList.add(PICK); }
    refreshAll();
  });

  /* Colour circles count as a bundle (Bundle and save, Jessie 25 Oct 2026): the other colour, reached from a circle on
     this page, goes in with the same stamps as a picked piece (row FAMILY, build swatch-v1), so the cart can tell. */
  var SW_KEY = 'sofiaSwatchFrom';
  function handleOf() { var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[data-sofia-sw], .sgb-also a'); if (!a) return;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/); if (!m) return;
    try { sessionStorage.setItem(SW_KEY, JSON.stringify({ from: handleOf(), to: decodeURIComponent(m[1]), t: Date.now() })); } catch (x) {}
  }, true);
  function stampSwatch() {
    var s = null; try { s = JSON.parse(sessionStorage.getItem(SW_KEY) || 'null'); } catch (x) {}
    if (!s || !s.from || s.to !== handleOf() || s.from === s.to || Date.now() - s.t > 2 * 3600 * 1000) return;
    document.querySelectorAll('.product__section--buttons form').forEach(function (f) {
      if (f.querySelector('input[data-sp-swatch]')) return;
      [['_bundle_anchor', s.from], ['_bundle_row', 'FAMILY'], ['_bundle_surface', 'pdp'], ['_bundle_build', 'swatch-v1']].forEach(function (kv) {
        var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + kv[0] + ']'; i.value = kv[1];
        i.setAttribute('data-sp-swatch', ''); f.appendChild(i);
      });
    });
  }

  function boot() {
    try { stampSwatch(); } catch (x) {}
    var hosts = [].filter.call(document.querySelectorAll('[data-cbx], [data-sgb-wrap]'), function (h) { return h.querySelector('[data-cbx-pick], [data-sgb-pick]'); });
    if (!hosts.length) return;
    document.documentElement.classList.add('sp-on');
    hosts.forEach(function (host) {
      /* The label Jessie chose (25 Oct 2026): "Bundle and save", no amount; the $5 shows in the cart. */
      if (!host.querySelector('.sp-save')) {
        var tag = document.createElement('p'); tag.className = 'sp-save'; tag.textContent = 'Bundle and save';
        var at = host.hasAttribute('data-cbx') ? host.firstElementChild : (host.querySelector('[data-sgb-box]') || host).firstElementChild;
        if (at) at.parentNode.insertBefore(tag, at); else host.insertBefore(tag, host.firstChild);
      }
      if (!host.querySelector('.sp-help')) {
        var p = document.createElement('p'); p.className = 'sp-help';
        if (host.hasAttribute('data-cbx')) {
          p.textContent = "Tick any extras you'd like. They go in with this piece when you press Add to cart.";
          var grid = host.querySelector('.cbx__grid'); if (grid) grid.parentNode.insertBefore(p, grid);
        } else {
          p.textContent = "Tick any you'd like. They go in with this piece when you press Add to cart.";
          var first = host.querySelector('[data-sgb-box]'), sub = first && (first.querySelector('.sgb__sub') || first.querySelector('.sgb-eyebrow'));
          if (sub) sub.insertAdjacentElement('afterend', p); else host.insertBefore(p, host.firstChild);
        }
      }
      host.querySelectorAll('[data-cbx-pick], [data-sgb-pick]').forEach(function (cb) {
        var a = cb.getAttribute('aria-label') || '';
        if (/^Add .+ to cart$/.test(a)) cb.setAttribute('aria-label', 'Pick ' + a.replace(/^Add /, '').replace(/ to cart$/, ''));
      });
      if ('MutationObserver' in window) {
        var tmr = null;
        new MutationObserver(function () { clearTimeout(tmr); tmr = setTimeout(refreshAll, 60); })
          .observe(host, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
    });
    document.querySelectorAll('.product__section--buttons .AddtoCart').forEach(guardText);
    refreshAll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
